import "./Modal.css";
import React from "react";
import CloseIcon from "assets/images/Close.png";

function Modal({ children, onClose, customStyle }) {
  
  const handleClose = () => {
    document.querySelector(".modal").classList.add('modal-content-active');
    setTimeout(function() {
      onClose()
    }, 300);
  }

  return (
    <div className="overlay">
      <div className={`modal modal-content ${customStyle}`}>
        <button className="closeButton" onClick={() => {handleClose()}}>
            <img src={CloseIcon} className="w-[25px] h-[23px] mt-[10px] mr-[30px] flex-shrink-0" alt=""/>
        </button>
        {children}
      </div>
    </div>
  );
}

export default Modal;